interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-accent-600">
          <span className="h-px w-6 bg-accent-400" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}